import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { triggerActionEvent } from './common';
import PSInput from './psinput';
import { defaultTheme } from '../../data/themes';

const PSTextArea = styled.textarea`
	background: ${props => props.theme.inputBackground ?? defaultTheme.inputBackground};
	color: ${props => props.theme.inputColor ?? defaultTheme.inputColor};
	border: ${props => props.theme.inputBorder ?? defaultTheme.inputBorder};
	border-radius: ${props => props.theme.inputBorderRadius ?? defaultTheme.inputBorderRadius};
	outline: ${props => props.theme.inputOutline ?? defaultTheme.inputOutline};
	font-weight: ${props => props.theme.inputFontWeight ?? defaultTheme.inputFontWeight};
	font-size: ${props => props.theme.inputFontSize ?? defaultTheme.inputFontSize};
	padding: ${props => props.theme.inputPadding ?? defaultTheme.inputPadding};
	min-width: ${props => props.minWidth};
	min-height: ${props => props.minHeight};
	resize: ${props => props.resize};

	&::selection {
		background: ${props => props.theme.inputSelectionBackground ?? defaultTheme.inputSelectionBackground};
		color: ${props => props.theme.inputSelectionColor ?? defaultTheme.inputSelectionColor};
	}

	&[readonly] {
		background: ${props => props.theme.inputReadOnlyBackground ?? defaultTheme.inputReadOnlyBackground};
		color: ${props => props.theme.inputReadOnlyColor ?? defaultTheme.inputReadOnlyColor};
	}

	::placeholder {
		color: ${props => props.theme.inputPlaceholderColor ?? defaultTheme.inputPlaceholderColor};
		font-weight: ${props => props.theme.inputPlaceHolderFontWeight ?? defaultTheme.inputPlaceHolderFontWeight};
	}

`;

export default class TextInput extends React.PureComponent {

	constructor() {
		super();
		this.state = {
			value: ''
		};
		this.onChange = this.onChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
	}

	getValue() {
		if (this.props.changeOnBlur) {
			return this.state.value || '';
		} else {
			return this.props.value || '';
		}
	}

	doChange(value) {
		if (this.props.onChange) {
			this.props.onChange(value);
		}
	}

	inputFilter(value) {
		if (this.props.inputFilter) {
			return this.props.inputFilter(value);
		} else {
			return value;
		}
	}

	onChange(e) {
		if (this.props.changeOnBlur) {
			this.setState({
				value: this.inputFilter(e.target.value)
			});
		} else {
			this.doChange(this.inputFilter(e.target.value));
		}
	}

	isModified() {
		return (this.state.value || '') !== (this.props.value || '');
	}

	onAction(el) {
		if (this.props.changeOnBlur && this.isModified()) {
			this.doChange(this.state.value);
		}
		triggerActionEvent(el);
	}

	onBlur() {
		if (this.props.changeOnBlur) {
			if (this.isModified()) {
				this.doChange(this.state.value);
			}
		}
		if (this.props.onBlur) {
			this.props.onBlur();
		}
	}

/*	componentWillUnmount() {
		console.log('cwu');
		if (this.props.changeOnBlur && this.isModified()) {
			console.log('cwu jooooo - ', this.state.value);
			this.doChange(this.state.value);
		}
	}*/

	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.propsValue === nextProps.value || !nextProps.changeOnBlur) {
			return null;
		}
		return {
			value: nextProps.value,
			propsValue: nextProps.value
		};
	}

	render() {
		if (this.props.multiline) {
			return (
				<PSTextArea
					type={this.props.password ? 'password' : 'text'}
					className={'ps-input text' + (this.props.readOnly ? ' readonly' : '')}
					placeholder={this.props.placeholder}
					maxLength={this.props.maxLength}
					value={this.getValue()}
					onChange={this.onChange}
					onKeyDown={(e) => {
						if (e.keyCode === 13) {
							const el = e.target;
							if ((el.selectionStart === 0) && (el.selectionEnd === el.value.length)) {
								e.preventDefault();
								this.onAction(e.target);
							}
						}
						if (this.props.onKeyDown) {
							this.props.onKeyDown(e);
						}
					}}
					spellCheck="false"
					autoComplete="off"
					name={this.props.name}
					data-name={this.props.name}
					rows={this.props.rows}
					readOnly={this.props.readOnly}
					data-autofocusid={this.props.autoFocusId}
					onBlur={this.onBlur}
					tabIndex={this.props.readOnly ? '-1' : '0'}
					minWidth={this.props.minWidth}
					minHeight={this.props.minHeight}
					resize={this.props.resize}
				/>
			);
		} else {
			return (
				<PSInput
					data-name={this.props.name}
					data-autofocusid={this.props.autoFocusId}
					maxLength={this.props.maxLength}
					textAlign={this.props.textAlign}
					type={this.props.password ? 'password' : 'text'}
					className={'ps-input text' + (this.props.readOnly ? ' readonly' : '')}
					placeholder={this.props.placeholder}
					value={this.getValue()}
					onChange={this.onChange}
					onKeyDown={(e) => {
						if (e.keyCode === 13) {
							this.onAction(e.target);
						}
						if (this.props.onKeyDown) {
							this.props.onKeyDown(e);
						}
					}}
					spellCheck="false"
					autoComplete="new-password"
					name={this.props.name}
					onBlur={this.onBlur}
					readOnly={this.props.readOnly}
					tabIndex={this.props.readOnly ? '-1' : '0'}
				/>
			);
		}
	}

}

